// @flow

import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import type { State as GlobalState } from '../../rootReducer';
import cinematicRevealVerticalKeyframes from '../../../keyframes/cinematicRevealVerticalKeyframes';

import Clock from './Clock';
import DatePresenter from './DatePresenter';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const DatePresenterContainer = styled.div`
  padding-top: 20px;
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.3s ease-in-out;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
`;

const today: Date = new Date();

type Props = {
  usTimeFormat: boolean
};

export function CurrentTimePresenter({ usTimeFormat }: Props) {
  return (
    <Container>
      <Clock usTimeFormat={usTimeFormat} />
      <DatePresenterContainer>
        <DatePresenter date={today} />
      </DatePresenterContainer>
    </Container>
  );
}

CurrentTimePresenter.propTypes = {
  usTimeFormat: PropTypes.bool
};

function mapStateToProps(state: GlobalState): Props {
  return {
    usTimeFormat: state.authentication.usTimeFormat
  };
}

export default connect(mapStateToProps)(CurrentTimePresenter);
